import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    add: 'Add an item',
    description:
      'Write your invoices in the blink of an eye by recording your recurring items.',
    title: 'Item catalog',
  },
  fr: {
    add: 'Ajouter un article',
    description:
      'Rédigez vos factures en un clin d’œil en enregistrant vos articles récurrents.',
    title: 'Catalogue des articles récurrents',
  },
} as const);

export default locales;
